export const mutations = {
  setUsersList: (state, payload) => {
    state.usersList = payload;
  },
  setUser: (state, payload) => {
    state.user = payload;
  },
  clearUser: state => (state.user = null)
};
